import React from 'react'
import { Link } from "react-router-dom"
import AcademyCourseCard from '../../components/AcademyCourseCard/AcademyCourseCard'

const Academy = () => {
    return (
        <div className="academyCont">
            <div className="leftAca">
                <h1 className="acaTitle">Academy</h1>
                <p className="acadeets">Expand your knowledge. Download a copy of our <span className="curgreen">curricumlum</span> to learn from some of the best digital experts in Africa.</p>
                <Link to="/"><button className="joinus-btn">CHOOSE COURSES</button></Link>
            </div>
            <div className="rightAca">
                <p className="newTag">New</p>
                <AcademyCourseCard title={"Intro to Content Creation"} time={"48"} text={"Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and"}  />
                <AcademyCourseCard title={"Intro to Design Thinking"} time={"48"} text={"Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and"}  />
                <AcademyCourseCard title={"Intro to Video Creation"} time={"48"} text={"Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and"}  />
            </div>
        </div>
    )
}

export default Academy
